import { talukaDeleteApi } from "../../api/taluka/talukaDeleteApi"

type PayloadShape = Parameters<typeof talukaDeleteApi>[0]

export async function talukaDeleteService(payload: PayloadShape, token: string) {
	return await talukaDeleteApi(payload, token)
}
